import { styled as r } from "styled-components";
import { Colors as t } from "../../../../../styles/colors/index.js";
import { Theme as o } from "../../../../../styles/themes/index.js";
import { SmallLight as e, SmallHeavy as i } from "../../../../../styles/typography/index.js";
import { MediaQuery as l } from "../../../../../styles/variables.js";
const a = r.p`
  ${e}
  margin: 0;
  overflow: hidden;
  height: 52px;
  position: relative;
  color: rgb(${t.Gray});
  width: 100%;
  text-overflow: ellipsis;

  @media ${l.SCREEN_MD_UP} {
    height: 54px;
  }

  strong {
    ${i}
    margin-right: 3px;
    color: rgb(${o.colors.Alpha});
  }
`, d = r.button`
  display: flex;
  text-decoration: none;
  padding: 8px 16px;
  overflow: hidden;
  background: rgb(${o.colors.Kilo});
  align-items: center;
  width: 100%;
  border-top: 1px solid rgb(${o.colors.Golf});

  ${a} {
    height: auto;
    white-space: nowrap;
    text-align: left;
  }
`, h = r.span`
  color: rgb(${o.colors.Alpha});
  display: flex;
  align-items: center;
  i {
    margin-right: 4px;
    font-size: 15px;
  }
`;
export {
  h as EmptyComment,
  d as FooterLastCommentCard,
  a as FooterLastCommentParagraph
};
